import { render, staticRenderFns } from "./TariffsInput.vue?vue&type=template&id=64db01e2&"
import script from "./TariffsInput.vue?vue&type=script&lang=js&"
export * from "./TariffsInput.vue?vue&type=script&lang=js&"
import style0 from "./TariffsInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports